import {Component, OnInit} from '@angular/core';
import {UserService} from '../../user-dashboard/shared/user.service';
import {UserInfo} from '../../user-dashboard/shared/user-info.model';
import {LoaderService} from '../../shared/services/loader.service';
import {ReportService} from '../../reports/shared/report.service';
import {Report} from '../../reports/shared/report.model';
import {finalize} from 'rxjs/operators';
import {NavigationService} from '../../shared/services/navigation.service';
import {AuthenticationService} from '../../shared/services/authentication.service';
import {environment} from '../../../environments/environment';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {

  user: UserInfo;
  powerBiReportId: string;

  /** permissions **/
  hasAnyPermission                   = true;
  canSeeCarrierLoadsManagementWidget = false;
  canSeeChepLoadsManagementWidget    = false;
  canSeeCarrierPodValidationWidget   = false;
  canSeeChepPodValidationWidget      = false;
  canSeeCarrierOverdueWidget         = false;
  canSeeChepOverdueWidget            = false;
  canSeeCarrierLoadTrackingWidget    = false;
  canSeeChepLoadTrackingWidget       = false;
  canSeeTnxWidget                    = false;
  canSeeFindLoadWidget               = false;

  constructor(private reportService: ReportService,
              private userService: UserService,
              private loaderService: LoaderService,
              private authService: AuthenticationService,
              public navigationService: NavigationService) {
    // Disable loading of home report as this feature is not used
    // this.loadHomeReport();
  }

  ngOnInit() {
    this.authService.userProfileLoadedBehavior().subscribe(userLoaded => {
      if (userLoaded) {
        this.hasAnyPermission                   = this.authService.hasAnyPermission();
        this.canSeeCarrierLoadsManagementWidget = this.authService.canSeeCarrierLoadsManagementWidget();
        this.canSeeChepLoadsManagementWidget    = this.authService.canSeeChepLoadsManagementWidget();
        this.canSeeCarrierPodValidationWidget   = this.authService.canSeeCarrierPodValidationWidget();
        this.canSeeChepPodValidationWidget      = this.authService.canSeeChepPodValidationWidget();
        this.canSeeCarrierOverdueWidget         = this.authService.canSeeCarrierOverdueWidget();
        this.canSeeChepOverdueWidget            = this.authService.canSeeChepOverdueWidget();
        this.canSeeCarrierLoadTrackingWidget    = this.authService.canSeeCarrierLoadTrackingWidget();
        this.canSeeChepLoadTrackingWidget       = this.authService.canSeeChepLoadTrackingWidget();
        this.canSeeTnxWidget                    = this.authService.canSeeTnxWidget() && environment.features.tnxDashboard;
        this.canSeeFindLoadWidget               = this.authService.canSeeFindLoadWidget();
      }
    })
  }

  private loadHomeReport() {
    this.loaderService.startLoad();
    this.userService.getHomeReport()
      .pipe(finalize(() => this.loaderService.stopLoad()))
      .subscribe((report: Report) => {
        this.powerBiReportId = report.powerBiId
      }, () => console.log('No home report configured'));
  }
}
